// extracted by mini-css-extract-plugin
module.exports = {"similar-section":"HouseInfoFooter_similar-section__wkmh2"};